export enum NATIVE_INTERACTION_MESSAGE_TYPE {
  GET_RECENT_KEYWORD_LIST = 'GET_RECENT_KEYWORD_LIST',
  ADD_RECENT_KEYWORD = 'ADD_RECENT_KEYWORD',
  REMOVE_RECENT_KEYWORD = 'REMOVE_RECENT_KEYWORD',
  REMOVE_ALL_RECENT_KEYWORD = 'REMOVE_ALL_RECENT_KEYWORD',
  REFRESH_RECENT_KEYWORD_LIST = 'REFRESH_RECENT_KEYWORD_LIST',
  REQUEST_CAMERA_PERMISSION = 'REQUEST_CAMERA_PERMISSION',
  CHECK_LOCATION_PERMISSION = 'CHECK_LOCATION_PERMISSION',
  GET_LOCATION_POSITION = 'GET_LOCATION_POSITION',
  REQUEST_LOCATION_PERMISSION = 'REQUEST_LOCATION_PERMISSION',
  VIEW_ADVERTISEMENT = 'VIEW_ADVERTISEMENT',
  REQUEST_TELEMEDICINE_ELIGIBLE_GROUP_TYPE = 'REQUEST_TELEMEDICINE_ELIGIBLE_GROUP_TYPE',
}
